import { render } from "./ChatMessageSection.vue?vue&type=template&id=236c34eb&scoped=true"
import script from "./ChatMessageSection.vue?vue&type=script&lang=js"
export * from "./ChatMessageSection.vue?vue&type=script&lang=js"

import "./ChatMessageSection.vue?vue&type=style&index=0&id=236c34eb&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236c34eb"]])

export default __exports__